import React, { useState, useEffect } from "react";
import IconButton from "../../../share/buttons/IconButton";
import Card from "../../../share/cards/Card";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../../Assets/Image/svg/addSession.svg";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../../share/modal/Modal";
import TicketInfo from "../../Ticket/TicketInfo";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { ReactComponent as TicketDot } from "../../../../Assets/Image/svg/ticketDot.svg";
import useFetch from "../../../../Hooks/useFetch";
import MainPagination from "../../../share/Pageination/MainPagination";
import { useCreate } from "../../../../Context/CreateContext";

const Ticket = (props) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [upload, setUpload] = useState(false);
    const [tickets, setTickets] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });
    const [del, setDel] = useState();
    const [edit, setEdit] = useState();

    useEffect(() => {
        getTicket.reFetch();
    }, [pagination]);

    const selectModal = () => {
        setUpload((prev) => !prev);
    };

    const getTicket = useFetch({
        method: "GET",
        url: `BootCampTicketService/${bootCamp.id}/tickets`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setTickets,
    });

    const deleteTicket = useFetch({
        method: "DELETE",
        url: `BootCampTicketService/${del}`,
        noHeader: false,
        caller: getTicket,
    });

    const handleDelete = (id) => {
        setDel(id);
        deleteTicket.reFetch();
    };

    const handleEdit = (id) => {
        setEdit(id);
        setUpload((prev) => !prev);
    };

    return (
        <div className=" mt-20">
            {tickets?.results.length !== 0 ? (
                <>
                    <div className="flex justify-between items-center mb-20">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            اطلاعات بلیت بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ ساخت بلیت جدید"
                            className="px-16 py-7"
                            onClick={() => selectModal()}
                        />
                    </div>
                    <Card className="SupportTicketTable-card SupportTicketTable-body  my-4 font-bold text-black-prim">
                        <div>نام بلیت</div>
                        <div>قیمت(تومان)</div>
                        <div>تعداد</div>
                        <div></div>
                    </Card>
                    {tickets?.results.map((i) => (
                        <Card
                            key={i.id}
                            className="SupportTicketTable-card SupportTicketTable-body  my-4 relative"
                        >
                            <div className=" absolute top-[31px] right-0">
                                <TicketDot />
                            </div>
                            <div className=" text-black-prim">
                                {i.ticket_name}
                            </div>
                            <div>{i.ticket_price}</div>
                            <div className=" text-purple-dark cursor-pointer">
                                {i.ticket_number}
                            </div>
                            <div className="">
                                <div className="flex">
                                    <IconButton
                                        data-tip="حذف"
                                        onClick={() => handleDelete(i.id)}
                                    >
                                        <Trash />
                                    </IconButton>
                                    <IconButton
                                        data-tip="ویرایش"
                                        onClick={() => handleEdit(i.id)}
                                    >
                                        <Edit />
                                    </IconButton>
                                </div>
                            </div>
                        </Card>
                    ))}
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={tickets?.results}
                        pageSize={tickets?.page_count}
                        className="mt-[3rem]"
                    />
                    <div className="flex  justify-between items-center mt-20">
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.prevStep}
                        >
                            <BsArrowRight />
                            <span>مرحله قبل</span>
                        </div>
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.nextStep}
                        >
                            <span>ثبت و ادامه</span>
                            <BsArrowLeft />
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div>
                        <EmptyCourseDash name="بلیت" show={setUpload} />
                        <div className="flex  justify-between items-center mt-20">
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.prevStep}
                            >
                                <span>مرحله قبل</span>
                                <BsArrowRight />
                            </div>
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.nextStep}
                            >
                                <span>ثبت و ادامه</span>
                                <BsArrowLeft />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <Modal show={upload} closeModal={selectModal}>
                <TicketInfo
                    getTicket={getTicket}
                    edit={edit}
                    setEdit={setEdit}
                    close={selectModal}
                />
            </Modal>
        </div>
    );
};

export default Ticket;
